if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: false,
      numberFilterTree: 2,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true,
      // filterTreeMobileStyle: 'style3', // 'style1', style2', 'style2-fullwidth','style3', 'style3-fullwidth'
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var ratioImage = getRatioImage(data);
    var imageAspectRatio = 100; 
    // var imageAspectRatio = ratioImage / getAspectRatio(data.images_info[0]) * 100;

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);
      
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);


    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    // Add lifestyle_tag
    itemHtml = itemHtml.replace(/{{lifestyle_tag}}/g, buildLifestyle_tag(data));

    //quickAdd
    itemHtml = itemHtml.replace(/{{quickAdd}}/g, buildQuickAdd(data));
    // soldOut
    itemHtml = itemHtml.replace(/{{soldout___badge}}/g, buildsoldout___badge(data));

    // Add Review 
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    let first_available_variant = data.variants[0];
    var html = '';
    if (images && Array.isArray(images) && images.length > 0) {
      // console.log(Utils.getProductMetafield(data, 'custom', 'shipping_restriction_info'));
      if(Utils.getProductMetafield(data, 'custom', 'shipping_restriction_info') != null){
      html += `<div class="card__media">  <div class="shipping_restriction_info">${Utils.getProductMetafield(data, 'custom', 'shipping_restriction_info')}</div>`;
     
      }else{
        html += '<div class="card__media">';
      }

      html+=`<div style="text-align: end;" class="wishlist_wrap"><a href="javascript: void(0)" class="icon-wishlist-heart-empty wishlist-btn grid-wishlist-btn heart-wishlist-animation" data-wishList data-gridHulkList data-added="false" data-proID="${data.id}" data-varID="${first_available_variant.id}">
      <div class="wishlist_btn_icon"><i class="heart-hulk-animation"><i class="icon-wishlist-heart-empty"></i></i></div>
      <span>Add to wishlist</span>
      <span class="count">(0)</span>
      </a></div>`;

      var aspectRatio = '',
        rangeWidths = boostPFSRangeWidths;

      var dataSrcSet = '',
        imgAlt = data.title,
        flipImageSrcSet = '';

      var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
        boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
        boostPFSThemeConfig.custom.show_secondary_image == true;

      for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

        if (activeSwapImage) {
          flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
        }

        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';

          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }

      aspectRatio = images[0]['width'] / images[0]['height'];
      html += '<div class="media media--transparent media--hover-effect"><img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + dataSrcSet + '" ' +
        'height="' + images[0].height + '" ' +
        'width="' + images[0].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';

      if (activeSwapImage) {
        html += '<img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + flipImageSrcSet + '" ' +
        'height="' + images[1].height + '" ' +
        'width="' + images[1].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';
      }
      html += '</div>';
      html += '</div>';
    } else {
      html += `<div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="#" class="full-unstyled-link">
                      ${data.title}
                    </a>
                  </h3>
                </div>
              </div>`;
    }
    return html;
  }

  function buildQuickAdd(data){
    // console.log(data);
    let product_form_id = 'quick-add-'+data.id;
    let first_available_variant = data.variants[0];
    let disabledFlag = '';
    let buttonText = boostPFSThemeConfig.label.add_to_card;
    if(!first_available_variant.available){
      disabledFlag = 'disabled';
      buttonText = boostPFSThemeConfig.label.sold_out;
    }
 

    var html = '' 
    // console.log('enable_quick_add - '+boostPFSThemeConfig.custom.enable_quick_add);
    // console.log('show_quick_view - '+boostPFSThemeConfig.custom.show_quick_view);
    if(boostPFSThemeConfig.custom.enable_quick_add){
    html += `<div class="quick-add">
                  <product-form>
                  <form method="post" action="/cart/add" id="${product_form_id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="id" value="${first_available_variant.id}" ${disabledFlag}>
                  <button
                  id="${product_form_id}-submit"
                  type="submit"
                  name="add"
                  class="quick-add__submit button button--full-width button--primary"
                  aria-haspopup="dialog"
                  aria-live="polite"
                  data-sold-out-message="true"
                 ${disabledFlag}>
                 <span> ${buttonText} </span>
                 <span class="sold-out-message hidden">${buttonText}</span>
                <div class="loading-overlay__spinner hidden">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
                </button>
                  </form>
                  </product-form>
                
              </div>`;
    }
    if(boostPFSThemeConfig.custom.show_quick_view){
      html+=`
       <div class="quick-view">
              <modal-opener data-modal="#QuickAdd-${data.id}">
                <button id="${product_form_id}-submit"  class="quick-add__submit button button--full-width button--secondary"
                  aria-haspopup="dialog" aria-labelledby="${product_form_id}-submit title-${boostPFSThemeConfig.custom.section_id}-${data.id}"
                  data-product-url="/products/${data.handle}" >
                Quick View
                  <div class="loading-overlay__spinner hidden">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                </button>
              </modal-opener>
              <quick-add-modal id="QuickAdd-${data.id}" class="quick-add-modal">
                <div role="dialog" aria-label="Choose options for ${data.title}" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">
                  <button id="ModalClose-${data.id}" type="button" class="quick-add-modal__toggle" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                  <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                </svg>
                </button>
                  <div id="QuickAddInfo-${data.id}" class="quick-add-modal__content-info">
                  </div>
                </div>
              </quick-add-modal>
            </div>      
      `;
    }
    return html;
  }

  function buildLifestyle_tag(data) {
    console.log(data)
    var html = '';
    if (Utils.getProductMetafield(data, 'accentuate', 'freeze_dried') || data.tags.includes('Freeze-Dried')) {
      html += `<div class="freeze_dried" title="Freeze Dried">
    <svg width="61" height="70" viewBox="0 0 61 70" fill="none" xmlns="http://www.w3.org/2000/svg" style="padding: 5px 10px;">
        <g clip-path="url(#clip0_15_61)">
        <path d="M2.5357 0.637985H58.7244C59.6736 0.637985 60.3498 1.51841 60.0767 2.41159C58.2952 8.14072 56.2927 16.3452 55.7075 25.9023C55.2654 33.3667 55.6815 41.8137 56.4747 44.9016C56.5658 45.2461 56.9169 46.5603 57.0599 48.385C57.1769 49.8268 57.0729 50.72 56.9689 52.6212C56.7868 55.8239 56.6958 57.4316 56.7868 57.9803C57.2419 60.6216 58.5033 61.0682 59.6086 64.2836C59.9857 65.3937 60.2068 66.4273 60.3368 67.2949C60.4538 68.1243 59.7907 68.8516 58.9324 68.8516C52.4566 69.1451 47.0341 69.2472 42.99 69.2982C35.968 69.3748 31.7028 69.4258 25.7472 69.2089C19.2844 68.9792 15.9554 68.6219 12.0153 68.9537C10.1688 69.1068 8.30931 68.9027 6.4758 69.1323C4.85035 69.3237 3.47196 69.63 2.23662 68.8644C1.95054 68.6857 1.19633 68.1626 0.845231 67.2439C0.494133 66.3252 0.728199 65.4703 0.80622 65.1641C1.98955 60.6471 2.71775 56.0025 3.99211 51.5111C5.68258 45.5778 5.95566 40.7291 6.02067 39.4276C6.21573 35.4593 5.92965 32.0653 5.7606 30.1003C5.42251 26.2596 5.18844 26.8338 4.26518 19.918C3.30292 12.7597 3.48497 11.6369 2.58772 8.95734C2.37966 8.34488 1.83351 6.76267 1.4434 4.55523C1.28735 3.66205 1.18333 2.85818 1.13131 2.1564C1.05329 1.35253 1.71647 0.663505 2.5357 0.663505V0.637985Z" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10"/>
        <path d="M0.819275 64.5899C2.62678 64.5516 5.40955 64.5261 8.85551 64.5899C12.3015 64.6537 13.9919 64.7557 16.8918 64.8451C21.43 64.9726 24.5769 64.8961 27.7628 64.8451C33.9005 64.743 44.1213 64.6664 59.6087 64.5899" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10"/>
        <path d="M1.85956 4.91252H15.1233" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M20.0776 4.91252H59.0105" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M13.6928 43.1152C14.8111 44.2126 16.8137 45.9096 19.6745 46.5731C25.6041 47.9512 29.3492 43.6001 37.0083 43.2811C39.1929 43.1918 42.6259 43.3959 46.9561 45.1823" stroke="#F95158" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M13.6928 48.8826C14.8111 49.9799 16.8137 51.677 19.6745 52.3405C25.6041 53.7185 29.3492 49.3675 37.0083 49.0485C39.1929 48.9592 42.6259 49.1633 46.9561 50.9497" stroke="#F95158" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M13.6928 54.65C14.8111 55.7474 16.8137 57.4444 19.6745 58.1079C25.6041 59.486 29.3492 55.1349 37.0083 54.8159C39.1929 54.7266 42.6259 54.9307 46.9561 56.7171" stroke="#F95158" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M30.4025 25.2388C31.4079 25.2388 32.223 24.439 32.223 23.4524C32.223 22.4658 31.4079 21.666 30.4025 21.666C29.397 21.666 28.582 22.4658 28.582 23.4524C28.582 24.439 29.397 25.2388 30.4025 25.2388Z" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10"/>
        <path d="M30.4025 21.4619V16.3835V12.1728" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M27.7757 14.5206L30.4024 16.3835" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M32.9511 14.5206L30.3244 16.3835" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M30.3244 25.4302V30.5086V34.7193" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M32.9511 32.3715L30.3244 30.5086" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M27.7757 32.3715L30.4024 30.5086" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M28.582 22.3168L24.2648 19.4969L20.6888 17.1619" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M21.2219 20.607L24.2647 19.4969" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M24.0956 16.3835L24.2257 19.5735" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M31.8979 24.5753L36.2021 27.3952L39.7781 29.7302" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M39.2449 26.2851L36.2021 27.3952" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M36.3712 30.5086L36.2411 27.3314" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M28.5429 24.3966L24.0437 26.8975L20.2986 28.9774" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M23.6796 30.062L24.0437 26.8975" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M21.1309 25.6471L24.0827 26.9741" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M32.093 22.5082L36.5922 19.9945L40.3373 17.9147" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M36.9563 16.8301L36.5922 19.9945" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M39.518 21.245L36.5532 19.9307" stroke="#004D72" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
        </g>
        <defs>
        <clipPath id="clip0_15_61">
        <rect width="61" height="70" fill="white"/>
        </clipPath>
        </defs>
    </svg>
    
        <p>Freeze Dried</p>
    </div> `;
    }
    if (Utils.getProductMetafield(data, 'accentuate', 'senior_dog') || data.tags.includes('Senior Dog')) {
      html += ` <div class="senior_dog" title="Senior Dog">
    
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
  <defs>
    <style>
      .senior_dog .cls-1, .senior_dog .cls-2, .senior_dog .cls-3 {
        stroke: #004d72;
      }

      .senior_dog .cls-1, .senior_dog .cls-2, .senior_dog .cls-3, .senior_dog .cls-4 {
        fill: none;
        stroke-width: 3px;
      }

      .senior_dog .cls-1, .senior_dog .cls-3, .senior_dog .cls-4 {
        stroke-miterlimit: 10;
      }

      .senior_dog .cls-2 {
        stroke-linejoin: round;
      }

      .senior_dog .cls-2, .senior_dog .cls-3 {
        stroke-linecap: round;
      }

      .senior_dog .cls-5 {
        fill: #d0e9f7;
        stroke-width: 0px;
      }

      .senior_dog .cls-4 {
        stroke: #f95158;
      }
    </style>
  </defs>
  <path class="cls-5" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
  <path class="cls-2" d="M125.9,43.3l22.9,20.5c4.7,4.3,9.9,8.1,15.4,11.2,4.3,2.4,7,7,7,11.9s-1.6,7.4-4.3,9.9l-8.8,8.3c-7.2,5.3-13.1,12.2-17.3,20l-1.1,2c-.7,1.3-2,2-3.4,2s-3.1-1-3.7-2.6l-6-16.1"></path>
  <path class="cls-2" d="M74.1,43.3l-22.9,20.5c-4.7,4.3-9.8,8.1-15.4,11.2-4.3,2.4-7,7-7,11.9s1.5,7.4,4.3,9.9l8.8,8.3c7.2,5.3,13.1,12.2,17.3,20l1.1,2c.7,1.3,2,2,3.4,2s3.1-1,3.7-2.6l6.4-15.9"></path>
  <path class="cls-2" d="M100,95.4v7.4l-10.4,9.7c-2,2-4.5,2.9-7.1,2.9-5.7,0-10-4.7-10-10s1-5.1,2.9-7.1"></path>
  <path class="cls-2" d="M100,95.4v7.4l10.4,9.7c2,2,4.5,2.9,7.1,2.9,5.7,0,10-4.7,10-10s-1-5.1-2.9-7.1"></path>
  <path class="cls-2" d="M131.8,99.3c5.2-10.7,7.3-16,7.3-23.4,0-11.6-5.1-23.8-13.1-32.5-3.9-4.2-11.9-7.5-17.6-7.5h-16.7c-5.7,0-13.7,3.3-17.6,7.5-8.1,8.8-13.1,20.9-13.1,32.5s2.1,12.8,7.3,23.4"></path>
  <path class="cls-2" d="M132.6,126.7c2.9,9.2,8.7,26.7,8.7,31.8"></path>
  <path class="cls-2" d="M67.4,126.7c-2.9,9.2-8.7,26.7-8.7,31.8"></path>
  <line class="cls-3" x1="93.1" y1="71.2" x2="108.4" y2="71.2"></line>
  <line class="cls-3" x1="76.6" y1="67.1" x2="81.2" y2="67.1"></line>
  <line class="cls-3" x1="118.8" y1="67.1" x2="123.4" y2="67.1"></line>
  <path class="cls-4" d="M109.2,86.7c0,5-7,7.9-9.2,7.9s-9.2-3.2-9.2-7.9,8.4-6.3,9.2-6.3c9.1,0,9.2,5.5,9.2,6.3h0Z"></path>
  <path class="cls-1" d="M91.6,67.8c0,7.4-6,13.3-13.3,13.3s-13.3-6-13.3-13.3,6-13.3,13.3-13.3,13.3,6,13.3,13.3Z"></path>
  <path class="cls-1" d="M135.1,67.8c0,7.4-6,13.3-13.3,13.3s-13.3-6-13.3-13.3,6-13.3,13.3-13.3,13.3,6,13.3,13.3Z"></path>
  <path class="cls-3" d="M96.8,124.9l-2,4.6c-.7,1.6-1.8,2-2.6.6l-1.6-11.1"></path>
  <path class="cls-3" d="M103.5,126.7l1.6,3.7c.7,1.6,2.2,3,3,1.5l1.2-12.3"></path>
  <path class="cls-3" d="M103.5,126.7l-2.1,4.4c-.7,1.6-1.7.9-2.5-.6l-2.1-5.5"></path>
</svg>
        <p>Senior Dog</p> 
    </div>`;
    }
    if (Utils.getProductMetafield(data, 'accentuate', 'puppy') || data.tags.includes('PUPPY')) {
      html += `<div class="puppy" title="Puppy">
    
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
  <defs>
    <style>
        .puppy .cls-1 {
            fill: #004d72;
       }
        .puppy .cls-1, .puppy .cls-2 {
            stroke-width: 0px;
       }
        .puppy .cls-3, .puppy .cls-4, .puppy .cls-5 {
            stroke: #004d72;
       }
        .puppy .cls-3, .puppy .cls-4, .puppy .cls-5, .puppy .cls-6 {
            fill: none;
            stroke-width: 3px;
       }
        .puppy .cls-3, .puppy .cls-5, .puppy .cls-6 {
            stroke-miterlimit: 10;
       }
        .puppy .cls-4 {
            stroke-linejoin: round;
       }
        .puppy .cls-4, .puppy .cls-5 {
            stroke-linecap: round;
       }
        .puppy .cls-2 {
            fill: #d0e9f7;
       }
        .puppy .cls-6 {
            stroke: #f95158;
       }
        
    </style>
  </defs>
  <path class="cls-2" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
  <path class="cls-1" d="M89.3,119.3c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4,1.5-3.4,3.4-3.4,3.4,1.5,3.4,3.4"></path>
  <path class="cls-1" d="M117.6,119.3c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4,1.5-3.4,3.4-3.4,3.4,1.5,3.4,3.4"></path>
  <path class="cls-4" d="M130.5,115.2v15.1c0,16.9-13.7,30.5-30.5,30.5s-30.5-13.7-30.5-30.5v-15.1"></path>
  <line class="cls-5" x1="97.7" y1="124" x2="102.3" y2="124"></line>
  <path class="cls-4" d="M100,148.1l-4.3,2.6c-1.9,1.1-4.3.8-5.8-.7"></path>
  <path class="cls-4" d="M100,148.1l4.3,2.6c1.9,1.1,4.3.8,5.8-.7"></path>
  <path class="cls-6" d="M100,138.2c3.8,0,7,1.1,7,3.2s-3.1,5.7-7,5.7-7-2.8-7-5.7,3.1-3.2,7-3.2Z"></path>
  <path class="cls-3" d="M71.4,139.3s-6.2,7.5-12,4.9c-5.8-2.6-15.5-7.1-11.1-18.8s-2.2-27.7,23.1-39.7c0,0,25.4-12.8,57.1,0,25.9,10.4,18.6,27.9,23.1,39.7,4.4,11.7-5.3,16.2-11.1,18.8-5.8,2.6-12-4.9-12-4.9"></path>
</svg>
        <p>Puppy</p> 
    </div>`;
    }
    if (Utils.getProductMetafield(data, 'accentuate', 'dog') || data.tags.includes('Dog')) {
      html += ` <div class="dog" title="Dog">
    
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
  <defs>
    <style>
        .dog .cls-1 {
            fill: #004d72;
       }
        .dog .cls-1, .dog .cls-2 {
            stroke-width: 0px;
       }
        .dog .cls-3 {
            stroke-linejoin: round;
       }
        .dog .cls-3, .dog .cls-4 {
            stroke: #004d72;
            stroke-linecap: round;
       }
        .dog .cls-3, .dog .cls-4, .dog .cls-5 {
            fill: none;
            stroke-width: 3px;
       }
        .dog .cls-2 {
            fill: #d0e9f7;
       }
        .dog .cls-4, .dog .cls-5 {
            stroke-miterlimit: 10;
       }
        .dog .cls-5 {
            stroke: #f95158;
       }
        
    </style>
  </defs>
  <path class="cls-2" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
  <path class="cls-3" d="M129.9,43.3l22.9,20.5c4.7,4.3,9.9,8.1,15.4,11.2,4.3,2.4,7,7,7,11.9s-1.6,7.4-4.3,9.9l-8.8,8.3c-7.2,5.3-13.1,12.2-17.3,20l-1.1,2c-.7,1.3-2,2-3.4,2s-3.1-1-3.7-2.6l-6-16.1"></path>
  <path class="cls-3" d="M78.1,43.3l-22.9,20.5c-4.7,4.3-9.8,8.1-15.4,11.2-4.3,2.4-7,7-7,11.9s1.5,7.4,4.3,9.9l8.8,8.3c7.2,5.3,13.1,12.2,17.3,20l1.1,2c.7,1.3,2,2,3.4,2s3.1-1,3.7-2.6l6.4-15.9"></path>
  <path class="cls-3" d="M104,95.4v7.4l-10.4,9.7c-2,2-4.5,2.9-7.1,2.9-5.7,0-10-4.7-10-10s1-5.1,2.9-7.1"></path>
  <path class="cls-1" d="M90.3,67.8c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4,1.5-3.4,3.4-3.4,3.4,1.5,3.4,3.4"></path>
  <path class="cls-3" d="M104,95.4v7.4l10.4,9.7c2,2,4.5,2.9,7.1,2.9,5.7,0,10-4.7,10-10s-1-5.1-2.9-7.1"></path>
  <path class="cls-1" d="M117.8,67.8c0,1.9,1.5,3.4,3.4,3.4s3.4-1.5,3.4-3.4-1.5-3.4-3.4-3.4-3.4,1.5-3.4,3.4"></path>
  <path class="cls-3" d="M94.8,112.6c2.5,2.5,5.9,3.8,9.2,3.8s6.7-1.3,9.2-3.8"></path>
  <path class="cls-3" d="M135.8,99.3c5.2-10.7,7.3-16,7.3-23.4,0-11.6-5.1-23.8-13.1-32.5-3.9-4.2-11.9-7.5-17.6-7.5h-16.7c-5.7,0-13.7,3.3-17.6,7.5-8.1,8.8-13.1,20.9-13.1,32.5s2.1,12.8,7.3,23.4"></path>
  <path class="cls-3" d="M136.7,126.7c2.9,9.2,8.7,26.7,8.7,31.8"></path>
  <path class="cls-3" d="M71.4,126.7c-2.9,9.2-8.7,26.7-8.7,31.8"></path>
  <line class="cls-4" x1="101.7" y1="71.2" x2="106.3" y2="71.2"></line>
  <path class="cls-5" d="M113.2,86.7c0,5-7,7.9-9.2,7.9s-9.2-3.2-9.2-7.9,8.4-6.3,9.2-6.3c9.1,0,9.2,5.5,9.2,6.3h0Z"></path>
</svg>
        <p>Dog</p> 
    </div>`;
    }
    if (Utils.getProductMetafield(data, 'accentuate', 'mealfree') || data.tags.includes('Meal-Free')) {
      html += ` <div class="mealfree" title="Meal-Free">
    
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
  <defs>
    <style>
        .mealfree .cls-1 {
            stroke: #f95158;
            stroke-linecap: round;
            stroke-linejoin: round;
       }
        .mealfree .cls-1, .mealfree .cls-2 {
            fill: none;
            stroke-width: 3px;
       }
        .mealfree .cls-3 {
            fill: #f95158;
       }
        .mealfree .cls-3, .mealfree .cls-4 {
            stroke-width: 0px;
       }
        .mealfree .cls-2 {
            stroke: #004d72;
            stroke-miterlimit: 10;
       }
        .mealfree .cls-4 {
            fill: #d0e9f7;
       }
        
    </style>
  </defs>
  <path class="cls-4" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
  <line class="cls-1" x1="75.2" y1="126.6" x2="116.8" y2="88.7"></line>
  <circle class="cls-1" cx="100" cy="100" r="69.7"></circle>
  <line class="cls-1" x1="144.4" y1="64.3" x2="154.2" y2="56.2"></line>
  <line class="cls-1" x1="50.2" y1="147.6" x2="65.9" y2="133.7"></line>
  <path class="cls-2" d="M116.8,124.1s.2-38.2,0-48.2c-6.8.9-12.6-4.4-12.6-10.9s4.9-11.1,11.1-11.1,7.1,1.9,9.1,4.7c2-2.8,5.3-4.7,9.1-4.7,6.1,0,11.1,5,11.1,11.1s-5.8,11.8-12.5,10.9c-.2,10.8-.2,37.4,0,48.2,6.8-.9,12.5,4.4,12.5,10.9s-4.9,11.1-11.1,11.1-7.1-1.9-9.1-4.7c-2,2.9-5.3,4.7-9.1,4.7-6.1,0-11.1-4.9-11.1-11.1s5.8-11.9,12.6-10.9h0Z"></path>
  <path class="cls-2" d="M93,148.9s-15.2-6.1-18.7-6.1-18.7,6.1-18.7,6.1c1.5-5.1,10.2-15.2,15.3-20.9.9-1,2.1-1.5,3.4-1.5s2.5.5,3.4,1.5c5.1,5.7,13.8,15.8,15.3,20.9h0Z"></path>
  <path class="cls-2" d="M61.1,77.3c-2.5,0-4.2-2.7-3.1-4.9,5.2-11.2,12.3-21.2,16.1-21.2s10.9,10.1,16.2,21.2c1.1,2.3-.6,4.9-3.1,4.9h-26.1,0Z"></path>
  <line class="cls-2" x1="74.1" y1="126.3" x2="74.1" y2="77.5"></line>
  <line class="cls-2" x1="88.4" y1="108" x2="59.9" y2="108"></line>
  <line class="cls-2" x1="92.4" y1="98.1" x2="55.8" y2="98.1"></line>
  <line class="cls-2" x1="92.4" y1="87.9" x2="55.8" y2="87.9"></line>
  <line class="cls-2" x1="84.3" y1="118.2" x2="64" y2="118.2"></line>
  <path class="cls-3" d="M80.5,65.2c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1,1.4-3.1,3.1-3.1,3.1,1.4,3.1,3.1"></path>
</svg>
        <p>Meal-Free</p> 
    </div>`;
    }
    if (Utils.getProductMetafield(data, 'accentuate', 'senior_cat') || data.tags.includes('Senior Cat')) {
      html += `<div class="senior_cat" title="Senior cat">
    
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
  <defs>
    <style>
        .senior_cat .cls-1 {
            fill: #004d72;
       }
        .senior_cat .cls-1, .senior_cat .cls-2, .senior_cat .cls-3 {
            stroke-width: 0px;
       }
        .senior_cat .cls-2 {
            fill: #f95158;
       }
        .senior_cat .cls-4, .senior_cat .cls-5, .senior_cat .cls-6 {
            fill: none;
            stroke: #004d72;
            stroke-width: 3px;
       }
        .senior_cat .cls-4, .senior_cat .cls-6 {
            stroke-miterlimit: 10;
       }
        .senior_cat .cls-5 {
            stroke-linejoin: round;
       }
        .senior_cat .cls-5, .senior_cat .cls-6 {
            stroke-linecap: round;
       }
        .senior_cat .cls-3 {
            fill: #d0e9f7;
       }
        
    </style>
  </defs>
  <path class="cls-3" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
  <path class="cls-1" d="M55.4,137.7c1.7-2.3,3.4-4.6,5.2-6.8,1.9-2.2,3.9-4.3,6-6.3,2.1-2,4.4-3.8,6.8-5.6,2.4-1.7,4.9-3.3,7.4-4.7,1.1-.6,2.5-.2,3.1.8.6,1.1.2,2.5-.8,3.1,0,0,0,0-.1,0h0c-2.5,1.2-4.9,2.5-7.3,4-2.3,1.5-4.6,3.1-6.7,4.9-2.2,1.8-4.2,3.7-6.1,5.7-1.9,2-3.7,4.1-5.6,6.4-.4.5-1.1.6-1.6.1-.5-.4-.5-1.1-.2-1.5h0s0,0,0,0Z"></path>
  <path class="cls-1" d="M45,119.4c5-3.9,10.7-7.1,16.8-9,3.1-1,6.2-1.7,9.4-2.2.8,0,1.6-.2,2.4-.3.8,0,1.6-.2,2.4-.2l4.7-.3c1.2,0,2.3.9,2.4,2.1,0,1.2-.9,2.3-2.1,2.4h-4.8c-.8,0-1.5,0-2.3,0-.7,0-1.5,0-2.2.1-3,.2-5.9.8-8.9,1.5-5.8,1.5-11.4,4.1-16.4,7.6h0c-.5.4-1.2.2-1.6-.3-.3-.5-.2-1.2.2-1.5"></path>
  <path class="cls-5" d="M73.7,72.7l6.8-3.8c-3.4-5.6-7.3-11.2-10.6-15.3"></path>
  <path class="cls-5" d="M126.7,72.7l-6.8-3.8c3.4-5.6,7.3-11.2,10.6-15.3"></path>
  <line class="cls-6" x1="70.9" y1="125" x2="86.4" y2="132.3"></line>
  <path class="cls-4" d="M57.5,113.6c1.8,3.1,4.7,5.7,8.3,8"></path>
  <path class="cls-4" d="M144.6,109.7c.5-1.7.7-3.4.7-5.4s-.4-5-1.2-8l-3.7-13.9c0-3.4.6-9.6.6-16.3,0-10-1.2-21.3-7.4-26.7h0c-7.1,0-22.6,25.7-22.6,25.7-5.1-1.1-7.9-1.6-10.8-1.6s-5.7.5-10.8,1.6c0,0-15.5-25.7-22.6-25.7h0c-6.2,5.5-7.4,16.8-7.4,26.7s.6,13,.6,16.3l-3.7,13.9c-.8,2.9-1.2,5.6-1.2,8s.3,3.8.8,5.5"></path>
  <path class="cls-4" d="M133.6,122.2c4.2-2.5,7.4-5.3,9.4-8.8"></path>
  <line class="cls-6" x1="114" y1="132.3" x2="129.3" y2="125.1"></line>
  <path class="cls-1" d="M142.9,139.1c-1.8-2.2-3.6-4.3-5.6-6.4-1.9-2-4-3.9-6.1-5.7-2.1-1.8-4.4-3.4-6.7-4.9-2.3-1.5-4.8-2.8-7.3-4h0c-1.1-.6-1.6-1.9-1-3.1.6-1.1,1.9-1.6,3-1,0,0,0,0,.1,0,2.6,1.5,5,3,7.4,4.7,2.4,1.7,4.6,3.6,6.8,5.6,2.1,2,4.1,4.1,6,6.3,1.9,2.2,3.6,4.6,5.2,6.8h0c.4.5.3,1.2-.2,1.6-.5.4-1.2.3-1.5-.2"></path>
  <path class="cls-1" d="M153.8,121.2c-5-3.5-10.6-6.1-16.4-7.6-2.9-.8-5.9-1.3-8.9-1.5-.8,0-1.5,0-2.2-.1-.8,0-1.5,0-2.3,0h-4.7c-1.2,0-2.3-1-2.3-2.3,0-1.2,1-2.3,2.3-2.3h.1l4.7.3c.8,0,1.6.1,2.4.2.8,0,1.6.2,2.4.3,3.2.5,6.3,1.2,9.4,2.2,6.1,2,11.8,5.1,16.8,9,.5.4.6,1.1.2,1.6-.4.5-1.1.6-1.5.2h0Z"></path>
  <path class="cls-5" d="M100,116.4l-4.6,2.7c-2,1.2-4.6.9-6.2-.8"></path>
  <path class="cls-5" d="M100,116.4l4.6,2.7c2,1.2,4.6.9,6.2-.8"></path>
  <line class="cls-6" x1="74.7" y1="93.3" x2="80.2" y2="93.3"></line>
  <line class="cls-6" x1="120.2" y1="93.3" x2="125.7" y2="93.3"></line>
  <path class="cls-5" d="M70,124.8c-4.8,8.1-10.6,28.3-10.9,35.9"></path>
  <path class="cls-5" d="M130,124.8c4.8,8.1,10.6,28.3,10.9,35.9"></path>
  <path class="cls-2" d="M107.4,105.1c-.7-1-1.8-1.5-3-1.5h-.5c-.9,0-1.8.4-2.5,1-.5.5-1.2.8-2,.8s-1.5-.3-2-.8c-.7-.6-1.5-1-2.5-1h-.5c-1.2,0-2.4.5-3,1.5-.9,1.4-.7,3.2.4,4.3l5.2,5.2c.7.7,1.6,1,2.4,1s1.8-.3,2.4-1l5.2-5.2c1.1-1.1,1.4-2.9.4-4.3"></path>
  <path class="cls-4" d="M91.6,92.8c0,7.4-6,13.3-13.3,13.3s-13.3-6-13.3-13.3,6-13.3,13.3-13.3,13.3,6,13.3,13.3Z"></path>
  <path class="cls-4" d="M135.1,92.8c0,7.4-6,13.3-13.3,13.3s-13.3-6-13.3-13.3,6-13.3,13.3-13.3,13.3,6,13.3,13.3Z"></path>
  <path class="cls-6" d="M97.3,138.2l-2,4.6c-.7,1.6-1.8,2-2.6.6l-1.6-11.1"></path>
  <path class="cls-6" d="M104,139.9l1.6,3.7c.7,1.6,2.2,3,3,1.5l1.2-12.3"></path>
  <path class="cls-6" d="M104,139.9l-2.1,4.4c-.7,1.6-1.7.9-2.5-.6l-2.1-5.5"></path>
  <line class="cls-4" x1="91.6" y1="92.8" x2="108.4" y2="92.8"></line>
</svg>
        <p>Senior cat</p> 
    </div>`;
    }
    if (Utils.getProductMetafield(data, 'accentuate', 'kitten') || data.tags.includes('KITTEN')) {
      html += `<div class="kitten" title="Kitten">
    
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
  <defs>
    <style>
        .kitten .cls-1 {
            fill: #004d72;
       }
        .kitten .cls-1, .kitten .cls-2, .kitten .cls-3 {
            stroke-width: 0px;
       }
        .kitten .cls-2 {
            fill: #f95158;
       }
        .kitten .cls-4, .kitten .cls-5, .kitten .cls-6 {
            fill: none;
            stroke: #004d72;
            stroke-width: 3px;
       }
        .kitten .cls-4, .kitten .cls-6 {
            stroke-miterlimit: 10;
       }
        .kitten .cls-5 {
            stroke-linejoin: round;
       }
        .kitten .cls-5, .kitten .cls-6 {
            stroke-linecap: round;
       }
        .kitten .cls-3 {
            fill: #d0e9f7;
       }
        
    </style>
  </defs>
  <path class="cls-3" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
  <path class="cls-4" d="M104.8,171.2c32.5-.8,38.1-24.5,38.1-24.5.5-1.6.7-3.3.7-5.2s-.4-4.7-1.1-7.5l-3.5-13.1c0-3.2.2-9,.5-15.3.3-5.4-.9-10.3-6.7-15.4h0c-6.7,0-21.5,14.4-21.5,14.4-4.8-1-7.5-1.5-10.1-1.5h-1.3c-2.7,0-5.3.5-10.1,1.5,0,0-14.8-14.4-21.5-14.4h0c-5.8,5.1-7,10-6.7,15.4.4,6.4.5,12.2.5,15.3l-3.5,13.1c-.8,2.8-1.1,5.2-1.1,7.5s.2,3.6.7,5.2c0,0,5.6,23.7,38.1,24.5h8.6Z"></path>
  <path class="cls-5" d="M100.6,153l-4.3,2.6c-1.9,1.1-4.3.8-5.8-.7"></path>
  <path class="cls-5" d="M100.6,153l4.3,2.6c1.9,1.1,4.3.8,5.8-.7"></path>
  <path class="cls-2" d="M108.1,142.3c-.6-.9-1.7-1.4-2.9-1.4h-.5c-.9,0-1.7.4-2.3.9-.5.4-1.2.7-1.9.7s-1.4-.3-1.9-.7c-.7-.6-1.4-.9-2.3-.9h-.5c-1.1,0-2.2.5-2.9,1.4-.9,1.3-.7,3,.4,4.1l4.9,4.9c.6.6,1.5.9,2.3.9s1.7-.3,2.3-.9l4.9-4.9c1.1-1.1,1.3-2.8.4-4.1"></path>
  <path class="cls-1" d="M87.1,132c0,3.6-2.9-1.8-6.4-1.8s-6.4,5.4-6.4,1.8,2.9-6.4,6.4-6.4,6.4,2.9,6.4,6.4"></path>
  <path class="cls-1" d="M126.9,132c0,3.6-2.9-1.8-6.4-1.8s-6.4,5.4-6.4,1.8,2.9-6.4,6.4-6.4,6.4,2.9,6.4,6.4"></path>
  <path class="cls-5" d="M73.9,111.5l5.7-2.8c-2.9-4.1-6.2-8.2-9-11.2"></path>
  <path class="cls-5" d="M125.7,111.5l-5.7-2.8c2.9-4.1,6.2-8.2,9-11.2"></path>
  <line class="cls-6" x1="97.9" y1="132.6" x2="103.2" y2="132.6"></line>
</svg>
        <p>Kitten</p> 
    </div>`;
    }
    if (Utils.getProductMetafield(data, 'accentuate', 'cat') || data.tags.includes('CAT')) {
      html += `<div class="cat" title="Cat">
    
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
  <defs>
    <style>
        .cat .cls-1 {
            fill: #004d72;
       }
        .cat .cls-1, .cat .cls-2, .cat .cls-3 {
            stroke-width: 0px;
       }
        .cat .cls-2 {
            fill: #f95158;
       }
        .cat .cls-4, .cat .cls-5, .cat .cls-6 {
            fill: none;
            stroke: #004d72;
            stroke-width: 3px;
       }
        .cat .cls-4, .cat .cls-6 {
            stroke-miterlimit: 10;
       }
        .cat .cls-5 {
            stroke-linejoin: round;
       }
        .cat .cls-5, .cat .cls-6 {
            stroke-linecap: round;
       }
        .cat .cls-3 {
            fill: #d0e9f7;
       }
        
    </style>
  </defs>
  <path class="cls-3" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
  <path class="cls-1" d="M55.4,137.7c1.7-2.3,3.4-4.6,5.2-6.8,1.9-2.2,3.9-4.3,6-6.3,2.1-2,4.4-3.8,6.8-5.6,2.4-1.7,4.9-3.3,7.4-4.7,1.1-.6,2.5-.2,3.1.8.6,1.1.2,2.5-.8,3.1,0,0,0,0-.1,0h0c-2.5,1.2-4.9,2.5-7.3,4-2.3,1.5-4.6,3.1-6.7,4.9s-4.2,3.7-6.1,5.7c-1.9,2-3.7,4.1-5.6,6.4-.4.5-1.1.6-1.6.1-.5-.4-.5-1.1-.2-1.5h0s0,0,0,0Z"></path>
  <path class="cls-1" d="M44.9,119.4c5-3.9,10.7-7.1,16.8-9,3.1-1,6.2-1.7,9.4-2.2.8,0,1.6-.2,2.4-.3.8,0,1.6-.2,2.4-.2l4.7-.3c1.2,0,2.3.9,2.4,2.1,0,1.2-.9,2.3-2.1,2.4h-4.8c-.8,0-1.5,0-2.2,0-.8,0-1.5,0-2.2.1-3,.2-5.9.8-8.9,1.5-5.8,1.5-11.4,4.1-16.4,7.6h0c-.5.4-1.2.2-1.6-.3-.3-.5-.2-1.2.2-1.5"></path>
  <path class="cls-5" d="M73.7,72.7l6.8-3.8c-3.4-5.6-7.3-11.2-10.6-15.3"></path>
  <path class="cls-5" d="M126.6,72.7l-6.8-3.8c3.4-5.6,7.3-11.2,10.6-15.3"></path>
  <line class="cls-6" x1="70.9" y1="125" x2="86.4" y2="132.3"></line>
  <path class="cls-4" d="M57.4,113.6c1.8,3.1,4.7,5.7,8.3,8"></path>
  <path class="cls-4" d="M144.6,109.7c.5-1.7.7-3.4.7-5.4s-.4-5-1.2-8l-3.7-13.9c0-3.4.6-9.6.6-16.3,0-10-1.2-21.3-7.4-26.7h0c-7.2,0-22.6,25.7-22.6,25.7-5.1-1.1-7.9-1.6-10.8-1.6s-5.7.5-10.8,1.6c0,0-15.5-25.7-22.6-25.7h0c-6.2,5.5-7.4,16.8-7.4,26.7s.6,13,.6,16.3l-3.7,13.9c-.8,2.9-1.2,5.6-1.2,8s.3,3.8.8,5.5"></path>
  <path class="cls-4" d="M133.6,122.2c4.2-2.5,7.4-5.3,9.4-8.8"></path>
  <line class="cls-6" x1="113.9" y1="132.3" x2="129.3" y2="125.1"></line>
  <path class="cls-1" d="M142.9,139.1c-1.8-2.2-3.6-4.3-5.6-6.4-1.9-2-4-3.9-6.1-5.7-2.1-1.8-4.4-3.4-6.7-4.9-2.3-1.5-4.8-2.8-7.3-4h0c-1.1-.6-1.6-1.9-1-3.1.6-1.1,1.9-1.6,3-1,0,0,0,0,.1,0,2.6,1.5,5,3,7.4,4.7,2.4,1.7,4.6,3.6,6.8,5.6,2.1,2,4.1,4.1,6,6.3,1.9,2.2,3.6,4.6,5.2,6.8h0c.4.5.3,1.2-.2,1.6-.5.4-1.2.3-1.5-.2"></path>
  <path class="cls-1" d="M153.7,121.2c-5-3.5-10.6-6.1-16.4-7.6-2.9-.8-5.9-1.3-8.9-1.5-.8,0-1.5,0-2.2-.1-.8,0-1.5,0-2.3,0h-4.7c-1.2,0-2.3-1-2.3-2.3,0-1.2,1-2.3,2.3-2.3h.1l4.7.3c.8,0,1.6.1,2.4.2.8,0,1.6.2,2.4.3,3.2.5,6.3,1.2,9.4,2.2,6.1,2,11.8,5.1,16.8,9,.5.4.6,1.1.2,1.6-.4.5-1.1.6-1.5.2h0Z"></path>
  <path class="cls-5" d="M100,116.4l-4.6,2.7c-2,1.2-4.6.9-6.2-.8"></path>
  <path class="cls-5" d="M100,116.4l4.6,2.7c2,1.2,4.6.9,6.2-.8"></path>
  <line class="cls-6" x1="97.7" y1="98.3" x2="102.2" y2="98.3"></line>
  <path class="cls-5" d="M70,124.8c-4.8,8.1-10.6,28.3-10.9,35.9"></path>
  <path class="cls-5" d="M129.9,124.8c4.8,8.1,10.6,28.3,10.9,35.9"></path>
  <path class="cls-1" d="M86.4,93.8c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4,1.5-3.4,3.4-3.4,3.4,1.5,3.4,3.4"></path>
  <path class="cls-1" d="M113.6,93.8c0,1.9,1.5,3.4,3.4,3.4s3.4-1.5,3.4-3.4-1.5-3.4-3.4-3.4-3.4,1.5-3.4,3.4"></path>
  <path class="cls-2" d="M107.4,105.1c-.7-1-1.8-1.5-3-1.5h-.5c-.9,0-1.8.4-2.5,1-.5.5-1.2.8-2,.8s-1.5-.3-2-.8c-.7-.6-1.5-1-2.5-1h-.5c-1.2,0-2.4.5-3,1.5-.9,1.4-.7,3.2.4,4.3l5.2,5.2c.7.7,1.6,1,2.4,1s1.8-.3,2.4-1l5.2-5.2c1.1-1.1,1.4-2.9.4-4.3"></path>
    </svg>
        <p>Cat</p> 
    </div>`;
    }

    if (Utils.getProductMetafield(data, 'accentuate', 'limited_ingrediets') || data.tags.includes('Limited Ingrediets')) {
      html += ` <div class="limited_ingrediets" title="Limited Ingrediets">
    
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
    <defs>
      <style>
        .limited_ingrediets .cls-1 {
	 fill: #004d72;
}
 .limited_ingrediets .cls-1, .limited_ingrediets .cls-2 {
	 stroke-width: 0px;
}
 .limited_ingrediets .cls-3 {
	 stroke-width: 4px;
}
 .limited_ingrediets .cls-3, .limited_ingrediets .cls-4, .limited_ingrediets .cls-5, .limited_ingrediets .cls-6, .limited_ingrediets .cls-7 {
	 fill: none;
}
 .limited_ingrediets .cls-3, .limited_ingrediets .cls-4, .limited_ingrediets .cls-6, .limited_ingrediets .cls-7 {
	 stroke-linecap: round;
}
 .limited_ingrediets .cls-3, .limited_ingrediets .cls-5, .limited_ingrediets .cls-6, .limited_ingrediets .cls-7 {
	 stroke: #004d72;
}
 .limited_ingrediets .cls-3, .limited_ingrediets .cls-5, .limited_ingrediets .cls-7 {
	 stroke-miterlimit: 10;
}
 .limited_ingrediets .cls-4 {
	 stroke: #f95158;
}
 .limited_ingrediets .cls-4, .limited_ingrediets .cls-5, .limited_ingrediets .cls-6, .limited_ingrediets .cls-7 {
	 stroke-width: 3px;
}
 .limited_ingrediets .cls-4, .limited_ingrediets .cls-6 {
	 stroke-linejoin: round;
}
 .limited_ingrediets .cls-2 {
	 fill: #d0e9f7;
}
 
      </style>
    </defs>
    <path class="cls-2" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
    <rect class="cls-5" x="58.1" y="150.3" width="83.7" height="8"></rect>
    <path class="cls-1" d="M102.3,50.6c0,1.7-1.3,3-3,3s-3-1.3-3-3,1.3-3,3-3,3,1.3,3,3"></path>
    <line class="cls-3" x1="95.3" y1="50.6" x2="103.3" y2="50.6"></line>
    <polyline class="cls-5" points="141.2 157.8 141.2 155.8 145.1 147.9 145.1 100 135.2 68.1 135.2 42.2 63.4 42.2 63.4 68.1 53.4 100 53.4 147.9 57.4 155.8 57.4 157.8"></polyline>
    <line class="cls-6" x1="99.1" y1="100.4" x2="124.4" y2="100.4"></line>
    <polyline class="cls-4" points="74.2 103.5 78.7 107.4 91.1 93.4"></polyline>
    <line class="cls-6" x1="99.1" y1="120.4" x2="124.4" y2="120.4"></line>
    <polyline class="cls-4" points="74.2 123.4 78.7 127.4 91.1 113.3"></polyline>
    <line class="cls-7" x1="63.4" y1="68.1" x2="105.7" y2="68.1"></line>
    <line class="cls-7" x1="117" y1="68.1" x2="135.2" y2="68.1"></line>
  </svg>
        <p>Limited Ingrediets</p> 
    </div>`;
    }
    if (Utils.getProductMetafield(data, 'accentuate', 'holistic') || data.tags.includes('Holistic')) {
      html += ` <div class="holistic" title="Holistic">
    
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
    <defs>
        <style>
            .holistic .cls-1, .holistic .cls-2 {
                stroke-linecap: round;
                stroke-linejoin: round;
           }
            .holistic .cls-1, .holistic .cls-2, .holistic .cls-3 {
                fill: none;
                stroke-width: 3px;
           }
            .holistic .cls-1, .holistic .cls-3 {
                stroke: #f95158;
           }
            .holistic .cls-4 {
                fill: #f95158;
           }
            .holistic .cls-4, .holistic .cls-5 {
                stroke-width: 0px;
           }
            .holistic .cls-2 {
                stroke: #004d72;
           }
            .holistic .cls-5 {
                fill: #d0e9f7;
           }
            .holistic .cls-3 {
                stroke-miterlimit: 10;
           }
            
        </style>
    </defs>
    <path class="cls-5" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
    <path class="cls-2" d="M168.5,102c-.3,37.6-30.9,67.9-68.5,67.9s-58.7-21.8-66.3-51.2"></path>
    <path class="cls-2" d="M54.2,119c-.7-1.7-.9-1.9-1.5-3.7"></path>
    <path class="cls-2" d="M149.2,101.4c0,6.5-1.3,12.7-3.5,18.4"></path>
    <path class="cls-2" d="M139.8,95.6l17.1-23.2c.7-.8,1.9-.8,2.6,0l22.8,30.9c1.3,1.4-.2,3.7-2,3l-11.9-4.6"></path>
    <line class="cls-2" x1="149.2" y1="101.2" x2="141.9" y2="104"></line>
    <path class="cls-2" d="M31.5,98c.3-37.5,30.9-67.9,68.5-67.9s58.7,21.8,66.3,51.3"></path>
    <path class="cls-2" d="M141.3,71.8c2.6,4,4.6,8.3,6,13"></path>
    <path class="cls-2" d="M50.8,98.6c0-27.2,22.1-49.2,49.2-49.2s28.1,6.6,37.2,16.9"></path>
    <path class="cls-2" d="M56.1,110l-12.9,17.6c-.7.8-1.9.8-2.6,0l-22.8-30.9c-1.3-1.4.2-3.7,2-3l11.9,4.6"></path>
    <line class="cls-2" x1="50.8" y1="98.8" x2="60.7" y2="95"></line>
    <path class="cls-1" d="M67,90.2c-4.5,2.5-7.6,5.4-8.6,8.7h0l-6.6,33.1c0,11.2,21.6,20.3,48.2,20.3s48.2-9.1,48.2-20.3l-6.6-33.1h0c-1-3.5-4.7-6.6-8.5-8.7"></path>
    <path class="cls-1" d="M141.9,101.1c0,9.8-18.8,17.7-41.9,17.7s-41.9-7.9-41.9-17.7"></path>
    <path class="cls-2" d="M131.9,98c0-2.8-1.8-5.1-4.3-5.9,0,0,0-.1,0-.2,0-3.9-2.4-7.2-5.8-8.7-1.5-4.3-5.6-7.4-10.5-7.4s-6.4,1.5-8.4,3.9c-1.5-4.1-5.4-7.1-10-7.1s-8.8,3.1-10.1,7.4c-.5,0-1-.2-1.6-.2-5.2,0-9.4,4.2-9.4,9.4s.3,2.4.7,3.5c-2.1,1.4-3.4,3.8-3.4,6.4"></path>
    <path class="cls-2" d="M97,90.2c2.9-4.3,8.8-5.4,13.1-2.4"></path>
    <path class="cls-2" d="M83.6,92.7c6.4-3.8,14.6-1.6,18.3,4.8"></path>
    <path class="cls-2" d="M74.1,103.4s7.4-2.1,12.1,3.7"></path>
    <path class="cls-2" d="M113.2,103.2s2.8-5.3,9.7-4.7"></path>
    <path class="cls-3" d="M94.5,137.1l1.8-1.1v-2.1c0-2,1.7-3.7,3.7-3.7s3.7,1.6,3.7,3.7v2.1l1.8,1.1c1.8,1,2.4,3.3,1.3,5-.7,1.2-1.9,1.9-3.2,1.9s-1.3-.2-1.8-.5l-1.8-1.1-1.8,1.1c-.6.3-1.2.5-1.8.5-1.3,0-2.5-.7-3.2-1.9-1-1.8-.4-4,1.3-5h0Z"></path>
    <path class="cls-4" d="M106.7,131.1c0,1.2,1,2.2,2.2,2.2s2.2-1,2.2-2.2-1-2.2-2.2-2.2-2.2,1-2.2,2.2"></path>
    <path class="cls-4" d="M101.5,125c0,1.2,1,2.2,2.2,2.2s2.2-1,2.2-2.2-1-2.2-2.2-2.2-2.2,1-2.2,2.2"></path>
    <path class="cls-4" d="M94.1,125c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2-1,2.2-2.2,2.2-2.2-1-2.2-2.2"></path>
    <path class="cls-4" d="M88.9,130.9c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2-1,2.2-2.2,2.2-2.2-1-2.2-2.2"></path>
    </svg>
        <p>Holistic</p> 
    </div>`;
    }
    if (Utils.getProductMetafield(data, 'accentuate', 'grain_free') || data.tags.includes('Grain-Free')) {
      html += ` <div class="grain_free" title="Grain Free">

<svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" data-name="Layer 2" version="1.1" viewBox="0 0 200 200">
  <defs>
    <style>
        .grain_free .cls-1 {
            stroke: #f95158;
            stroke-linecap: round;
            stroke-linejoin: round;
       }
        .grain_free .cls-1, .grain_free .cls-2 {
            fill: none;
            stroke-width: 3px;
       }
        .grain_free .cls-2 {
            stroke: #004d72;
            stroke-miterlimit: 10;
       }
        .grain_free .cls-3 {
            fill: #d0e9f7;
            stroke-width: 0px;
       }
        
    </style>
  </defs>
  <path class="cls-3" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
  <path class="cls-2" d="M108.3,70.5c0,8.6-4.4,15.5-7.3,15.5s-7.3-6.9-7.3-15.5,7.3-15.5,7.3-15.5c0,0,7.3,7,7.3,15.5Z"></path>
  <path class="cls-2" d="M93.5,99.3c6.6,6.2,8.9,14.6,6.8,16.8-1.8,1.9-10.7.7-17.3-5.5-6.6-6.2-6.8-16.8-6.8-16.8,0,0,10.7-.7,17.3,5.5h0Z"></path>
  <path class="cls-2" d="M108.6,99.3c-6.6,6.2-8.9,14.6-6.8,16.8,1.8,1.9,10.7.7,17.3-5.5,6.6-6.2,6.8-16.8,6.8-16.8,0,0-10.7-.7-17.3,5.5h0Z"></path>
  <circle class="cls-1" cx="100" cy="100" r="69.7"></circle>
  <line class="cls-1" x1="122.7" y1="83.9" x2="154.2" y2="56.2"></line>
  <line class="cls-1" x1="50.2" y1="147.6" x2="71.6" y2="128.8"></line>
  <path class="cls-2" d="M93.9,80.3c6.3,5.8,8.4,13.8,6.4,15.9-1.7,1.8-10.1.6-16.3-5.2-6.3-5.8-6.4-15.9-6.4-15.9,0,0,10.1-.6,16.3,5.2Z"></path>
  <path class="cls-2" d="M108.1,80.3c-6.3,5.8-8.4,13.8-6.4,15.9,1.7,1.8,10.1.6,16.3-5.2,6.3-5.8,6.4-15.9,6.4-15.9,0,0-10.1-.6-16.3,5.2h0Z"></path>
  <path class="cls-2" d="M114.9,116.6c-9.4,4.7-14.7,13.4-13,16.6,1.4,2.7,11.7,4.2,21.1-.5,9.4-4.7,13-16.6,13-16.6,0,0-11.7-4.2-21.1.5h0Z"></path>
  <path class="cls-2" d="M87.2,116.6c9.4,4.7,14.7,13.4,13,16.6-1.4,2.7-11.7,4.2-21.1-.5-9.4-4.7-13-16.6-13-16.6,0,0,11.7-4.2,21.1.5h0Z"></path>
</svg>
    <p>Grain Free</p> 
</div>`;
    }
    if (Utils.getProductMetafield(data, 'custom', 'vegan') || data.tags.includes('Vegan')) {
      html += ` <div class="vegan" title="Vegetarian">

<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" version="1.1" viewBox="0 0 200 200">
  <defs>
    <style>
        .vegan .cls-1 {
            stroke: #f95158;
            stroke-linecap: round;
       }
        .vegan .cls-1, .vegan .cls-2 {
            fill: none;
            stroke-miterlimit: 10;
            stroke-width: 3px;
       }
        .vegan .cls-2 {
            stroke: #004d72;
       }
        .vegan .cls-3 {
            fill: #d0e9f7;
            stroke-width: 0px;
       }
        
    </style>
  </defs>
  <path class="cls-3" d="M200,100c0,55.2-44.8,100-100,100S0,155.2,0,100,44.8,0,100,0s100,44.8,100,100"></path>
  <line class="cls-1" x1="96.6" y1="97.1" x2="94.1" y2="64.5"></line>
  <line class="cls-1" x1="103.6" y1="137.6" x2="70.9" y2="140.1"></line>
  <line class="cls-1" x1="74.1" y1="123.3" x2="72.1" y2="97.1"></line>
  <line class="cls-1" x1="96.1" y1="113" x2="122.1" y2="109.2"></line>
  <path class="cls-2" d="M109.4,97.1l-50.1,55.1c16.8,16,45.4,2.5,45.4,2.5,65.5-28.8,37.4-114.8,37.4-114.8-116.7,12.9-86.9,104.2-86.9,104.2l47.2-52.1,1.1-1c1.5-1.8,4.1-2,5.9-.5,1.8,1.5,2,4.1.5,5.9l-.5.6h0Z"></path>
</svg>
    <p>Vegetarian</p> 
</div>`;
    }

    // console.log(Utils.getProductMetafield(data, 'custom', 'organic'));
    // console.log(Utils.getProductMetafield(data, 'custom', 'dairyfree'));
    // console.log(Utils.getProductMetafield(data, 'custom', 'keto'));
    // console.log(Utils.getProductMetafield(data, 'custom', 'gluten_free'));
    // console.log(Utils.getProductMetafield(data, 'custom', 'low_sodium'));
    // console.log(Utils.getProductMetafield(data, 'custom', 'paleo'));
    // console.log(Utils.getProductMetafield(data, 'custom', 'sugar_free'));
    // console.log(Utils.getProductMetafield(data, 'custom', 'vegan'));
    // console.log(Utils.getProductMetafield(data, 'custom', 'vegetarian'));

    return html;
  }

  function buildCardProductClass(data) {
    var html = '' + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'h5';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor === true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    // var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
    // var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);

    // customise price 
    var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min).replace(/\.00$/,'') : Utils.formatMoney(data.price_min).replace(/\.00$/,'');
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min).replace(/\.00$/,'') : Utils.formatMoney(data.compare_at_price_min).replace(/\.00$/,'');


    var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount) : priceAmount;
    var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
    html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular">
                ${moneyPrice}
              </span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span>
                <s class="price-item price-item--regular">
                  ${compareAtPrice}
                </s>
              </span>
              <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
              <span class="price-item price-item--sale price-item--last">
                ${moneyPrice}
              </span>
            </div>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
              </span>
            </small>
          </div>
        </div>`
    return html;
  }

  function buildsoldout___badge(data){
  // console.log(data); 
  var soldOutbadgeLabel = '';
  if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
    soldOutbadgeLabel = 'soldout';
  }
  return soldOutbadgeLabel;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }
    
  function getAspectRatio(data) {
    var width = (data == null) ? '535' : data.width;
    var height = (data == null) ? '535' : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if(paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());
    

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    jQ(Selector.topSorting + ' .facet-filters__sort').change(function(e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    //       additional ad code 
    var extraItemHtml = `
    <li class="grid__item text-image-grid-item">  
      <div class="collection-grid-image-con"> 
        <a href="${boostPFSThemeConfig.custom.adButtonLink}" title="" class="grid__item__overlay-link"></a>
          <div class="boost-pfs-action-overlay" >
            <div class="img-wrapper">
              <img src="${boostPFSThemeConfig.custom.adImage}">
            </div>
            <div class="text-btn-wrap">
              <h2> ${boostPFSThemeConfig.custom.adHeading}</h2>
              <div class="mega-menu__richtext">            
                <p title="${boostPFSThemeConfig.custom.adText}">${boostPFSThemeConfig.custom.adText}</p>
              </div> 
              <a class="more-btn button button--primary" href="${boostPFSThemeConfig.custom.adButtonLink}"> 
              ${boostPFSThemeConfig.custom.adButtonText}
              </a> 
            </div>
        </div>
      </div>
    </li>`;
    
    const el = document.querySelector('ul#main-collection-product-grid li:nth-child(5)')
    if (el) el.insertAdjacentHTML('afterend', extraItemHtml);
  //       additional ad code  end

  }

  // Build Additional Elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');

    // END Boost 151758
    if (Utils.isMobile()) {
      if ( eventType !== 'sort') jQ('.boost-pfs-filter-options-wrapper').append('<div class="boost-pfs-filter-option"><div class="boost-pfs-filter-my-custom-sorting boost-pfs-filter-option-title"><div class="boost-pfs-filter-sorting-title-text">Sort by:</div><div class="pfs--sorting-container">' + ProductSorting.prototype.compileTemplate() + '</div></div></div>');
      jQ('.boost-pfs-filter-options-wrapper .boost-pfs-filter-my-custom-sorting select').change(function(e) {
        e.preventDefault();
        FilterApi.setParam('sort', jQ(this).val());
        FilterApi.setParam('page', 1);
        FilterApi.applyFilter('sort');
      });
    }
    // Boost 151758

  };

  /************************** END BUILD TOOLBAR **************************/
})();
